(() => {
  if (window.PickyScores) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animated = new WeakSet();
  const observed = new WeakSet();
  const frames = new Map();
  const format = value => String(Math.round(value * 10) / 10);
  const itemsFor = list => [...list.querySelectorAll('.picky-score-item')].map(item => {
    const count = item.querySelector('[data-picky-score-count]');
    return { count, fill: item.querySelector('.picky-score-fill'), bar: item.querySelector('.picky-lab__fill'), max: Number(count?.dataset.pickyScoreMax || 10), score: Number(count?.dataset.pickyScoreCount) };
  }).filter(item => item.count && Number.isFinite(item.score) && item.score >= 0 && item.score <= item.max && item.max > 0);
  const paint = (item, progress) => {
    if (item.fill) item.fill.style.strokeDasharray = `${item.score / item.max * 100 * progress} 100`;
    if (item.bar) item.bar.style.width = `${item.score / item.max * 100 * progress}%`;
    item.count.textContent = item.max === 100 ? String(Math.round(item.score * progress)) : format(item.score * progress);
  };
  const cancel = list => {
    if (frames.has(list)) cancelAnimationFrame(frames.get(list));
    frames.delete(list);
  };
  const finish = list => {
    cancel(list);
    itemsFor(list).forEach(item => paint(item, 1));
  };
  const animate = (list, replay = false) => {
    if (!list || (!replay && animated.has(list))) return;
    animated.add(list);
    cancel(list);
    if (motion.matches) { finish(list); return; }
    const items = itemsFor(list);
    if (!items.length) return;
    items.forEach(item => paint(item, 0));
    const start = performance.now();
    const duration = 1150;
    const stagger = 90;
    const frame = now => {
      if (!list.isConnected) { frames.delete(list); return; }
      if (motion.matches) { finish(list); return; }
      items.forEach((item, index) => {
        const elapsed = Math.min(Math.max((now - start - index * stagger) / duration, 0), 1);
        paint(item, 1 - Math.pow(1 - elapsed, 3));
      });
      if (now - start < duration + (items.length - 1) * stagger) frames.set(list, requestAnimationFrame(frame));
      else finish(list);
    };
    frames.set(list, requestAnimationFrame(frame));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { observer.unobserve(entry.target); animate(entry.target); }
    });
  }, { threshold: 0.35 }) : null;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-picky-score-replay]').forEach(button => { button.hidden = motion.matches; });
    scope.querySelectorAll('[data-picky-score-list]').forEach(list => {
      if (motion.matches) { finish(list); return; }
      if (animated.has(list) || observed.has(list)) return;
      if (observer) { observed.add(list); observer.observe(list); }
      else animate(list);
    });
  };
  document.addEventListener('click', event => {
    const replay = event.target.closest('[data-picky-score-replay]');
    if (replay) {
      replay.closest('[data-picky-score-panel]')?.querySelectorAll('[data-picky-score-list]').forEach(list => { observer?.unobserve(list); animate(list, true); });
      return;
    }
    const alternative = event.target.closest('[data-picky-score-variant]');
    if (!alternative || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const select = alternative.closest('[data-product-root]')?.querySelector('[data-variant-select]');
    const id = alternative.dataset.pickyScoreVariant;
    const destination = new URL(alternative.href, window.location.href);
    if (!select || select.disabled || ![...select.options].some(option => option.value === id) || destination.pathname !== window.location.pathname || destination.origin !== window.location.origin) return;
    event.preventDefault();
    select.value = id;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    window.history.replaceState(window.history.state, '', destination.href);
    select.focus({ preventScroll: true });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) {
      const root = event.target.closest('[data-product-root]');
      if (!root) return;
      root.querySelectorAll('[data-picky-score-profile]').forEach(profile => {
        const chosen = [...profile.querySelectorAll('template[data-picky-score-template]')].find(template => template.dataset.pickyScoreTemplate === event.target.value);
        const panel = profile.querySelector('[data-picky-score-panel]');
        if (!chosen || !panel || profile.dataset.activeVariant === event.target.value) return;
        panel.querySelectorAll('[data-picky-score-list]').forEach(list => { observer?.unobserve(list); cancel(list); });
        panel.replaceChildren(chosen.content.cloneNode(true));
        profile.dataset.activeVariant = event.target.value;
        const status = profile.querySelector('[data-picky-score-status]');
        if (status) status.textContent = panel.querySelector('.picky-score-setup')?.textContent || panel.querySelector('.picky-score-unavailable')?.textContent || '';
        init(panel);
      });
    }
    if (event.target.matches('[data-paddle-brand-filter]')) {
      const region = event.target.closest('.picky-score-compare');
      region?.querySelectorAll('[data-paddle-brand]').forEach(row => { row.hidden = Boolean(event.target.value) && row.dataset.paddleBrand !== event.target.value; });
    }
  });
  motion.addEventListener('change', () => {
    if (motion.matches) document.querySelectorAll('[data-picky-score-list]').forEach(finish);
    init();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('picky:ratings:refresh', event => init(event.target));
  window.PickyScores = { init, replay: list => animate(list, true) };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
